import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, getpayment, getaccommodationSetup} from '../../../services/event/accommodationForm/accommodationServices';
import { Modal, Button, Form} from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';
import Swal from 'sweetalert2';
const subDomain = localStorage.getItem('sub_domain') || '';

const Accommodation = () => {
  const [dataList, setDataList] = useState([]);
  const [names, setNames] = useState([]);
  const [form, setForm] = useState({
    id: '',
    pr_id: '',
    first_name : '',
    last_name : '',
    occupancy : '',
    no_of_nights : '',
    accompany_name : '',
    check_in : '',
    check_out : '',
    remarks : '',
    hotel_name : '',
    conf_shortname : '',
    sub_domain : '',
    series : '',
    venue : '',
    confirmation_no: '',
    verified: '',
    updatedAt : ''
  });
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [series, setSeries] = useState('');

  // Fetch all dropdown data
  const fetchData = useCallback(async () => {
    try {
      const data = await getData({sub_domain: subDomain });
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);
  const fetchPaymentData = useCallback(async () => {
    try {
      if (!series) return; 
      const data = await getpayment({sub_domain: subDomain, accommodation: 1, series });
      console.log('data', data);
      setNames(data); // Set payment data
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, [series]);

  const fetchaccommodationSetup = useCallback(async () => {
        try {
          const data = await getaccommodationSetup({ sub_domain: subDomain });
          if (data && data.length > 0) {
            const accommodationSetupInfo = data[0]; // Assuming you're using the first item
            setForm(prev => ({
              ...prev,
              series: accommodationSetupInfo.series || '',
              sub_domain: accommodationSetupInfo.sub_domain || '',
              hotel_name: accommodationSetupInfo.hotel_name || '',
              conf_shortname: accommodationSetupInfo.conf_shortname || '',
              venue: accommodationSetupInfo.venue || ''                                   
            }));
            setSeries(accommodationSetupInfo.series || '');  
          }
        } catch (error) {
          console.error('Failed to fetch accommodation info:', error);
        }
      }, []);
  

  useEffect(() => {
    const fetchDataAsync = async () => {
      setLoading(true); 
      await fetchData();
      await fetchPaymentData();
      await fetchaccommodationSetup(); 
      // Optional 2 second delay
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false); 
    };
    fetchDataAsync();
 
  }, [fetchData, fetchPaymentData, fetchaccommodationSetup]);
  
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    // Generic change for other fields
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));

  };

  const validateForm = () => {
    const newErrors = {};
  
    if (!form.first_name) newErrors.first_name = 'first_name is required';
    if (!form.last_name) newErrors.last_name = 'last_name is required';
    if (!form.occupancy) newErrors.Occupancy = 'Occupancy is required';
    if (!form.no_of_nights) newErrors.no_of_nights = 'No of nights is required';
    if (!form.accompany_name) newErrors.accompany_name = 'accompany_name is required';
    if (!form.check_in) newErrors.check_in = 'check_in is required';
    if (!form.check_out) newErrors.check_out = 'check_out is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  const handleSubmit = async () => {
    if (!validateForm()) return;
    try {
      console.log("Form data to be submitted:", form);
  
      if (modalType === 'add') {
        await addData(form);
      } else if (modalType === 'edit') {
        const updatedForm = { ...form, verified: 0 }; // Set status to 1
        await updateData(updatedForm);
      }
  
      fetchData();
      setShowModal(false);
      // ✅ Show success alert with auto-close
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: `Accommodation ${modalType === 'add' ? 'added' : 'updated'} successfully!`,
        timer: 2000, // 2 seconds
        showConfirmButton: false,
      });

    } catch (error) {
      console.error('Error during form submission:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something went wrong while submitting the form!',
      });
    }
  };
  
  const openModal = async (type, data = {
        id: '',
        pr_id: '',
        accommodation_status: '',
        first_name : '',
        last_name : '',
        occupancy : '',
        no_of_nights : '',
        accompany_name : '',
        check_in : '',
        check_out : '',
        remarks : '',
        hotel_name : '',
        conf_shortname : '',
        sub_domain : '',
        series : '',
        venue : '',
        confirmation_no: '',
        verified: '0',
        updatedAt : ''
    }) => {
      setErrors({}); // ✅ Clear previous errors
      setModalType(type);
      setForm(data);
    
      if (type === 'add' || type === 'edit') {
    try {
      const accommodationData = await getaccommodationSetup({ sub_domain: subDomain });

      if (accommodationData?.length > 0) {
        data.series = accommodationData[0].series;
        data.sub_domain = accommodationData[0].sub_domain;
        data.venue = accommodationData[0].venue;
        data.hotel_name = accommodationData[0].hotel_name;
        data.conf_shortname = accommodationData[0].conf_shortname;
        setShowModal(true); // ✅ Open modal only if data found
      } else {
        // ❌ No details found → Show warning
        Swal.fire({
          icon: 'warning',
          title: 'No Accommodation Setup Found',
          text: `No accommodation details found for the subdomain "${subDomain}".please contact management for assistance.`,
          confirmButtonColor: '#3085d6',
        });
      }
    } catch (error) {
      console.error('Error fetching accommodation setup:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error Fetching Data',
        text: 'Something went wrong while retrieving accommodation details.',
        confirmButtonColor: '#d33',
      });
    }
    }
    };
 
    const handleSearchChange = (e) => {
      setSearchText(e.target.value);
    };
  
    const handlePageChange = (page) => {
      setCurrentPage(page);
    };
    const handleNameChange = (selectedName) => {
    const selectedPerson = names.find(
      (person) => person.billing_full_name === selectedName
    );

    if (selectedPerson) {
      setForm((prevForm) => ({
        ...prevForm,
        full_name: selectedPerson.billing_full_name,
        accommodation_status: selectedPerson.accommodation_status,
        pr_id: selectedPerson.payment_id,
        occupancy: selectedPerson.occupancy_type,
        no_of_nights: selectedPerson.total_no_of_nights,
      }));
    }
  };

  // Memoized filtered data based on search query
  const filteredData = useMemo(() => {
    return dataList.filter(
      (data) =>
        data.first_name.toLowerCase().includes(searchText.toLowerCase()) ||
        data.last_name.toLowerCase().includes(searchText.toLowerCase()) ||
        data.accompany_name.toLowerCase().includes(searchText.toLowerCase())
    ).sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)); // Descending by updatedAt
  }, [dataList, searchText]);

  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '60px',
    },
    {
      name: 'First Name',
      selector: (row) => row.first_name,
      sortable: true,
    },
    {
      name: 'Last Name',
      selector: (row) => row.last_name,
      sortable: true,
    },
    {
      name: 'Accompany Name',
      selector: (row) => row.accompany_name,
      sortable: true,
    },
    {
      name: 'Occupancy',
      selector: (row) => row.occupancy,
      sortable: true,
    },
    {
      name: 'No of Nights',
      selector: (row) => row.no_of_nights,
      sortable: true,
    },
    {
  name: 'Status',
  selector: (row) => row.verified,
  sortable: true,
  cell: (row) => {
    let bgColor = '';
    let label = '';

    switch (row.verified) {
      
      case 3:
        bgColor = 'bg-danger'; // Red
        label = 'Cancelled';
        break;
        case 2:
        bgColor = 'bg-success'; // Green
        label = 'Verified';
        break;
        case 1:
        bgColor = 'bg-info'; // Grey
        label = 'Staging';
        break;
        case 0:
        bgColor = 'bg-warning'; // Yellow
        label = 'Pending';
        break;
      default:
            bgColor = 'bg-secondary text-dark';
            label = 'Unknown';
        }

        return (
        <span className={`rounded-pill text-center text-white px-3 py-1 ${bgColor}`}>
            {label}
        </span>
        );
    },
    }, 
    {
      name: 'Actions',
      cell: (row) => (
        <div>
        <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)} > Edit </Button>
        </div>
      ),
    },
  ];
 
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        
        {loading ? (
                <div
                    className="d-flex justify-content-center align-items-center w-100"
                    style={{ minHeight: "300px" }}
                  >
                    <Spinner /> {/* Centered Spinner */}
                  </div>
                          ) :(
                  <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
            <p className='fs-4'>Conference Management / Accommodation Form</p>
            </div>
            <div className="col-4 text-end">
            <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>
                Add
            </button>
            </div>
          </div>
 
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 20, 50, 100, 200, 500]}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />
 
          {/* Modal for Add/Edit data */}
          <Modal show={showModal} backdrop="static" className='modal-xl' onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <div className="row">
                <h4>Conference Details</h4>
                <div className="table-responsive">
                    <table className="table table-bordered table-striped align-middle">
                    <tbody>
                        <tr>
                        <th>Venue</th>
                        <td>{form.venue || '-'}</td>
                        </tr>
                        <tr>
                        <th>Series</th>
                        <td>
                            {form.series
                            ? new Date(form.series + '-01').toLocaleString('en-US', {
                                month: 'long',
                                year: 'numeric',
                                })
                            : '-'}
                        </td>
                        </tr>
                        <tr>
                        <th>Subdomain</th>
                        <td>{form.sub_domain || '-'}</td>
                        </tr>
                        <tr>
                        <th>Hotel Name</th>
                        <td>{form.hotel_name || '-'}</td>
                        </tr>
                        <tr>
                        <th>Conf Shortname</th>
                        <td>{form.conf_shortname || '-'}</td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                </div>
                 <hr />
                <div className='row'>
                <h4>Participant Details</h4>
                {modalType === 'add' && (
                <Form.Group className="col-md-6  mb-3">
                  <Form.Label>Confirmend Participants</Form.Label>
                  <Form.Select
                    name="full_name"
                    value={form.full_name}
                    onChange={(e) => handleNameChange(e.target.value)} // send payment_id
                  >
                    <option value="">-- Select --</option>
                    {names
                    .filter((item) => {
                      // Show all names that haven't been refunded yet,
                      // OR match the currently selected pr_id (for editing)
                      return (
                        !dataList.some((d) => d.pr_id === item.payment_id) ||
                        item.payment_id === form.pr_id
                      );
                    })
                    .map((item) => (
                      <option key={item.billing_full_name} value={item.billing_full_name}>
                        {item.billing_full_name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                 )}
                <div className="table-responsive">
                    <table className="table table-bordered table-striped align-middle">
                    <tbody>
                        <tr>
                        <th>Payment ID</th>
                        <td>{form.pr_id || '-'}</td>
                        </tr>
                        {modalType === 'add' && (
                        <tr>
                        <th>Full Name</th>
                        <td>{form.full_name || '-'}</td>
                        </tr>
                        )}
                        <tr>
                        <th>Accommodation Status</th>
                        <td>{form.accommodation_status || '-'}</td>
                        </tr>
                    </tbody>
                    </table>
                </div>  
                </div>
                <div className="col-md-12 mb-3 ">
                	<span><b className="text-primary">Note: </b>Split the full name into first name and last name as per the confirmed participants.</span> 
               </div>
                 <hr />
                 <div className='row'> 
                 <h4>Accommodation Details</h4>
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control type="text" name="first_name" value={form.first_name} onChange={handleChange} isInvalid={!!errors.first_name}/>
                <Form.Control.Feedback type="invalid">  {errors.first_name} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control type="text" name="last_name" value={form.last_name} onChange={handleChange} isInvalid={!!errors.last_name}/>
                  <Form.Control.Feedback type="invalid">  {errors.last_name} </Form.Control.Feedback>
                </Form.Group> 
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label>Occupancy</Form.Label>
                  <Form.Control type="text" name="occupancy" value={form.occupancy} onChange={handleChange} isInvalid={!!errors.occupancy}/>
                 <Form.Control.Feedback type="invalid">  {errors.occupancy} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label>No of Nights</Form.Label>
                  <Form.Control type="text" name="no_of_nights" value={form.no_of_nights} onChange={handleChange} isInvalid={!!errors.no_of_nights}/>
                  <Form.Control.Feedback type="invalid">  {errors.no_of_nights} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label>Accompany Name</Form.Label>
                  <Form.Control type="text" name="accompany_name" value={form.accompany_name} onChange={handleChange} isInvalid={!!errors.accompany_name}/>
                  <Form.Control.Feedback type="invalid">  {errors.accompany_name} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label>Check In</Form.Label>
                  <Form.Control type="date" name="check_in" value={form.check_in} onChange={handleChange} isInvalid={!!errors.check_in}/>
                  <Form.Control.Feedback type="invalid">  {errors.check_in} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label>Check Out</Form.Label>
                  <Form.Control type="date" name="check_out" value={form.check_out} onChange={handleChange} isInvalid={!!errors.check_out}/>
                  <Form.Control.Feedback type="invalid">  {errors.check_out} </Form.Control.Feedback>
                </Form.Group>
                {modalType === 'edit' && (
                <Form.Group className="col-md-12 mb-3">
                <Form.Label>Remarks</Form.Label>
                <Form.Control as="textarea" rows={3} name="remarks" value={form.remarks} onChange={handleChange}/>
                </Form.Group>  
                )}            
                </div>
                <Form.Control type="hidden" name="venue" value={form.venue} />
                <Form.Control type="hidden" name="series" value={form.series} />
                <Form.Control type="hidden" name="sub_domain" value={form.sub_domain} />
                <Form.Control type="hidden" name="hotel_name" value={form.hotel_name} />
                <Form.Control type="hidden" name="conf_shortname" value={form.conf_shortname} />
               <Form.Control type="hidden" name="pr_id" value={form.pr_id} />
                <Form.Control type="hidden" name="full_name" value={form.pr_id} />          
               <Form.Control type="hidden" name="accommodation_status" value={form.accommodation_status} />          
          
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
              <Button variant="primary" onClick={handleSubmit}> {modalType === 'add' ? 'Add' : 'Save'} </Button>
            </Modal.Footer>
          </Modal>
 
         
        </div>
        <Footer />
      </div>
      )};
    </div>
    </div>
  );
};
 
export default Accommodation;